import { Stack } from '@mui/material';
import { IPaymentsAndDeductions } from 'API/paymentAndDeductions';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useEffect, useState } from 'react';
import { PaymentDeduction } from './PaymentDeduction';
import { FilteredCategories } from './FilteredCategories';
import { PaginationResult2 } from 'Components';
import { useIsDesktop } from 'Hooks';
import { maxPaymentsAndDeductionsPerPage } from '..';
interface IPaymentsDeductionList {
  filteredPaymentsDeductions: IPaymentsAndDeductions[];
  dispatchPaymentsDeductions: Function;
  loadAllPaymentsDeductions: Function;
  paymentsDeductionsCount: number;
}

export const PaymentsDeductionList = ({
  filteredPaymentsDeductions,
  dispatchPaymentsDeductions,
  loadAllPaymentsDeductions,
  paymentsDeductionsCount,
}: IPaymentsDeductionList) => {
  const [pagination, setPagination] = useState<boolean>(false);
  const isDesktop = useIsDesktop();

  useEffect(() => {
    setPagination(paymentsDeductionsCount === maxPaymentsAndDeductionsPerPage);
  }, [paymentsDeductionsCount]);

  return (
    <>
      <FilteredCategories
        resultNumber={filteredPaymentsDeductions.length}
        dispatchPaymentsDeductions={dispatchPaymentsDeductions}
      />
      <Stack direction='column' gap={isDesktop ? '48px' : '32px'}>
        <Stack gap={isDesktop ? '24px' : '20px'}>
          {filteredPaymentsDeductions.map(
            (item: IPaymentsAndDeductions, index: number) => {
              if (pagination && index >= maxPaymentsAndDeductionsPerPage)
                return null;
              return (
                <PaymentDeduction key={index} paymentDeductionItem={item} />
              );
            }
          )}
        </Stack>
        {paymentsDeductionsCount >= maxPaymentsAndDeductionsPerPage && (
          <PaginationResult2
            text={
              pagination
                ? Dictionary[DICTIONARY.PaymentsDeductions].pagination
                : Dictionary[DICTIONARY.PaymentsDeductions].closeList
            }
            onClick={() => {
              setPagination(!pagination);
              if (paymentsDeductionsCount === maxPaymentsAndDeductionsPerPage)
                loadAllPaymentsDeductions();
            }}
            isPaginated={!pagination}
          />
        )}
      </Stack>
    </>
  );
};
